import * as React from 'react';
import * as Site from '../../shared/Site';
import { Translate } from '../../shared/LanguageService';
import moment from 'moment';

interface IProps {
    index: number;
    item: any;
}

const StylingUserCalendarPrintEventsListRow = (props: IProps) => {
    const blockedEventType = 4;
    return (
        <tbody className="no-top-border">
            <tr className={Site.getOrderCssClass(props.item.site)}>
                <th className="nobreak text-center">
                    {props.item.type !== blockedEventType &&
                        Translate(
                            'photographercalendar/printevents/modal/body/table/header/ordernumber'
                        )}
                </th>
                <th className="nobreak text-center">
                    {Translate('photographercalendar/printevents/modal/body/table/header/date')}
                </th>
                <th className="nobreak text-center">
                    {Translate('photographercalendar/printevents/modal/body/table/header/start')}
                </th>
                <th className="nobreak text-center">
                    {Translate('photographercalendar/printevents/modal/body/table/header/end')}
                </th>
                <th className="no-word-break text-center">
                    {Translate('photographercalendar/printevents/modal/body/table/header/package')}
                </th>
                <th className="nobreak text-center">
                    {Translate(
                        'photographercalendar/printevents/modal/body/table/header/numberOfimages'
                    )}
                </th>
                <th className="nobreak text-left">
                    {Translate('photographercalendar/printevents/modal/body/table/header/adress')}
                </th>
            </tr>
            <tr className={Site.getOrderCssClass(props.item.site)}>
                <td className="nobreak text-center">{props.item.orderNumber}</td>
                <td className="nobreak text-center">{moment(props.item.start).format('D[/]M')}</td>
                <td className="nobreak text-center">{moment(props.item.start).format('LT')}</td>
                <td className="nobreak text-center">{moment(props.item.end).format('LT')}</td>
                <td className="no-word-break text-center">{props.item.title}</td>
                <td className="nobreak text-center">{props.item.numberOfImages}</td>
                <td className="nobreak text-left">{props.item.description}</td>
            </tr>
            {props.item.type !== blockedEventType && (
                <tr
                    className={
                        Site.getOrderCssClass(props.item.site) +
                        ' visible-print-table-row valign-top'
                    }
                >
                    <td colSpan={10} className="no-padding">
                        <table width="100%" className="table even-line-height">
                            <tbody>
                                <tr className="no-border">
                                    <th colSpan={1}>
                                        {Translate(
                                            'photographer-events/table/header/address-line-1'
                                        )}
                                        <br />
                                        {Translate('photographer-events/table/header/address-city')}
                                        <br />
                                        {Translate(
                                            'photographer-events/table/header/address-postal-number'
                                        )}
                                        <br />
                                        {Translate('photographer-events/table/header/object-type')}
                                        <br />
                                        {Translate(
                                            'photographer-events/table/header/address-district'
                                        )}
                                        <br />
                                        {Translate(
                                            'photographer-events/table/header/object-area-square-meters'
                                        )}
                                        <br />
                                        {Translate(
                                            'photographer-events/table/header/object-number-of-rooms'
                                        )}
                                        <br />
                                        {Translate(
                                            'photographer-events/table/header/contact-person'
                                        )}
                                        <br />
                                        {Translate('photographer-events/table/header/floor')}
                                        <br />
                                        {Translate('photographer-events/table/header/access-code')}
                                        <br />
                                        {Translate('photographer-events/table/header/has-balcony')}
                                        <br />
                                        {Translate(
                                            'photographer-event/table/header/broker-attending'
                                        )}
                                    </th>
                                    <td colSpan={5} className="no-word-break">
                                        {props.item.bookableOrderAddressInfo.address_line1}
                                        &nbsp;
                                        <br />
                                        {props.item.bookableOrderAddressInfo.city}
                                        &nbsp;
                                        <br />
                                        {props.item.bookableOrderAddressInfo.zip}
                                        &nbsp;
                                        <br />
                                        {Translate(props.item.objectType)}&nbsp;
                                        <br />
                                        {props.item.bookableOrderAddressInfo.district}
                                        &nbsp;
                                        <br />
                                        {props.item.bookableOrderAddressInfo.objectAreaSquareMeters}
                                        &nbsp;
                                        <br />
                                        {props.item.bookableOrderAddressInfo.objectNumberOfRooms}
                                        &nbsp;
                                        <br />
                                        {props.item.bookableOrderInfo.availableContactPersons &&
                                            Translate(
                                                props.item.bookableOrderInfo.availableContactPersons.filter(
                                                    (x: any) =>
                                                        x.value ===
                                                        props.item.bookableOrderInfo.contactPerson
                                                )[0].displayName
                                            )}
                                        &nbsp;
                                        <br />
                                        {props.item.bookableOrderAddressInfo.apartmentFloor}
                                        &nbsp;
                                        <br />
                                        {props.item.bookableOrderAddressInfo.apartmentAccessCode}
                                        &nbsp;
                                        <br />
                                        {props.item.bookableOrderAddressInfo.apartmentHasBalcony
                                            ? Translate(
                                                  'photographer-events/ordermodal/form/view-label/object-type/apartment/has-balcony/yes'
                                              )
                                            : Translate(
                                                  'photographer-events/ordermodal/form/view-label/object-type/apartment/has-balcony/no'
                                              )}
                                        <br />
                                        {props.item.bookableOrderInfo.willAttendWhenPhotographing
                                            ? Translate(
                                                  'photographer-events/ordermodal/form/view-label/object-type/apartment/broker-attending/yes'
                                              )
                                            : Translate(
                                                  'photographer-events/ordermodal/form/view-label/object-type/apartment/broker-attending/no'
                                              )}
                                    </td>
                                    <th>
                                        <h5>
                                            {Translate(
                                                'calendarmodal/panel-owner-info/title/owner-info'
                                            )}
                                        </h5>
                                        {Translate(
                                            'photographer-events/table/header/owner-first-name'
                                        )}
                                        <br />
                                        {Translate(
                                            'photographer-events/table/header/owner-last-name'
                                        )}
                                        <br />
                                        {Translate(
                                            'photographer-events/table/header/owner-secondary-phone-number'
                                        )}
                                        <br />
                                        {Translate(
                                            'photographer-events/table/header/owner-primary-phone-number'
                                        )}
                                        <br />
                                        <h5>
                                            {Translate(
                                                'calendarmodal/panel-broker-info/title/broker-info'
                                            )}
                                        </h5>
                                        {Translate('photographer-events/table/header/broker/name')}
                                        <br />
                                        {Translate(
                                            'photographer-events/table/header/broker/phone-number'
                                        )}
                                        <br />
                                        {Translate('photographer-events/table/header/broker/email')}
                                    </th>
                                    <td>
                                        <h5>&nbsp;</h5>
                                        {props.item.bookableOrderOwnerContactInfo.firstName}
                                        &nbsp;
                                        <br />
                                        {props.item.bookableOrderOwnerContactInfo.lastName}
                                        &nbsp;
                                        <br />
                                        {props.item.bookableOrderOwnerContactInfo.secondaryPhoneNumber}
                                        &nbsp;
                                        <br />
                                        {props.item.bookableOrderOwnerContactInfo.primaryPhoneNumber}
                                        &nbsp;
                                        <br />
                                        <h5>&nbsp;</h5>
                                        {props.item.bookableOrderBrokerContactInfo.fullName}
                                        &nbsp;
                                        <br />
                                        {props.item.bookableOrderBrokerContactInfo.primaryPhoneNumber}
                                        &nbsp;
                                        <br />
                                        {props.item.bookableOrderBrokerContactInfo.email}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            )}
            {props.item.type !== blockedEventType &&
                props.item.photographerInstructions &&
                props.item.photographerInstructions.length > 0 && (
                    <tr
                        className={
                            Site.getOrderCssClass(props.item.site) +
                            ' visible-print-table-row valign-top'
                        }
                    >
                        <td colSpan={10}>
                            {props.item.photographerInstructions.map((x, index: number) => (
                                <dl key={index}>
                                    <dt>
                                        {Translate(
                                            'photographer-events/ordermodal/panel/title/photographer-instructions'
                                        )}{' '}
                                        - {x.productName}
                                    </dt>
                                    <dd>{x.photographerInstructions}</dd>
                                </dl>
                            ))}
                        </td>
                    </tr>
                )}
            {props.item.type !== blockedEventType &&
                (props.item.photographerInformationFromChain ||
                    props.item.photographerInformationFromFirm ||
                    props.item.photographerInformationFromOrder) && (
                    <tr
                        className={
                            Site.getOrderCssClass(props.item.site) +
                            ' visible-print-table-row valign-top'
                        }
                    >
                        <td colSpan={10}>
                            <div className="photographer-event-info-container">
                                <div className="photographer-event-info-column">
                                    <div>
                                        <strong>
                                            {Translate(
                                                'photographer-events/table/header/information-from-chain'
                                            )}
                                            :
                                        </strong>
                                    </div>
                                    {props.item.photographerInformationFromChain && (
                                        <div className="no-word-break">
                                            {props.item.photographerInformationFromChain}
                                        </div>
                                    )}
                                </div>
                                <div className="photographer-event-info-column">
                                    <div>
                                        <strong>
                                            {Translate(
                                                'photographer-events/table/header/information-from-firm'
                                            )}
                                            :
                                        </strong>
                                    </div>
                                    {props.item.photographerInformationFromFirm && (
                                        <div className="no-word-break">
                                            {props.item.photographerInformationFromFirm}
                                        </div>
                                    )}
                                </div>
                                <div className="photographer-event-info-column">
                                    <div>
                                        <strong>
                                            {Translate(
                                                'photographer-events/table/header/photographer-information-from-order'
                                            )}
                                            :
                                        </strong>
                                    </div>
                                    {props.item.photographerInformationFromOrder && (
                                        <div className="no-word-break">
                                            {props.item.photographerInformationFromOrder}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </td>
                    </tr>
                )}
        </tbody>
    );
};

export default StylingUserCalendarPrintEventsListRow;
